import { Fields } from "../../types/SchemaFactory";
import { TFunction } from "i18next";
import { schemaFactory } from "../SchemaFactory";
import { getMaxEnumValue } from "../../tools/EnumTools";
import { WorkCategory } from "../../domain/enums/WorkCategoryEnum";
import { worksCategoriesFields } from "./WorksCategoriesSchema";
import { WorkSearchSortForm } from "../../domain/models/dto/WorkDTO";
import { SortingOrder } from "../../domain/enums/common/SortingOrderEnum";
import { addressFieldsFactory } from "../AddressSchema";

export const workSearchSortFields: Fields<WorkSearchSortForm> = {
    title: {
        min: 2,
        max: 30,
        required: false,
        placeholderKey: "catalog.search.title",
        type: "text",
        initial: "",
    },
    address: {
        min: 0,
        max: 1,
        required: false,
        type: "schema",
        schema: addressFieldsFactory(false),
        initial: null,
        placeholderKey: "",
    },
    categories: {
        min: 0,
        max: getMaxEnumValue(WorkCategory),
        required: false,
        placeholderKey: "",
        type: "schema",
        schema: worksCategoriesFields,
        array: true,
        initial: [],
    },
    showInactive: {
        min: 0,
        max: 1,
        required: true,
        placeholderKey: "",
        type: "boolean",
        initial: false,
    },
    price: {
        min: 0,
        max: 100,
        required: false,
        placeholderKey: "",
        type: "text",
        initial: SortingOrder.DEFAULT,
    },
    distance: {
        min: 0,
        max: 100,
        required: false,
        placeholderKey: "",
        type: "text",
        initial: SortingOrder.DEFAULT,
    },
    startFrom: {
        min: 0,
        max: 100,
        required: false,
        placeholderKey: "",
        type: "text",
        initial: SortingOrder.DEFAULT,
    },
};

export const workSearchSortSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, workSearchSortFields);
};
